module.exports = __webpack_public_path__ + "static/media/perfect-result.fd3be61b.gif";